const initState = {}

export function jobs(state = initState, action) {
  switch (action.type) {
    default:
      return state
  }
}
